import initialState from '../store/initialState'
import busersTypes from '../constants/busersTypes'

export default function busersReducer(state = initialState.busers, action) {
  switch (action.type) {

    case busersTypes.set_errors: {
      return {
        ...state,
        errors: action.payload
      }
    }

    case busersTypes.reset_buser: {
      return {
        ...initialState.busers,
        items: state.items,
        buser: state.buser,
        totals: state.totals,
        pagination: state.pagination
      }
    }

    case busersTypes.clear_buser: {
      return {
        ...initialState.busers,
        buser: {
        },
        items: state.items,
        totals: state.totals,
        pagination: state.pagination,
      }
    }
    // GET
    case busersTypes.get.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        errors: []
      }
    }

    case busersTypes.get.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        buser: action.payload,
        errors: []
      }
    }

    case busersTypes.get.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        errors: action.payload
      }
    }

    // UPDATE
    case busersTypes.update.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case busersTypes.update.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        errors: [],
        buser: action.payload
      }
    }

    case busersTypes.update.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    // INDEX
    case busersTypes.index.request: {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: []
      }
    }

    case busersTypes.index.success: {
      if (action.payload.serial && state.serial && action.payload.serial < state.serial) {
        // ignore
        // console.log('index request ignored; consequent request already served')
        return {
          ...state
        }
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        items: action.payload.busers,
        pagination: action.payload.pagination,
        totals: action.payload.totals,
        serial: action.payload.serial || 0,
        errors: []
      }
    }

    case busersTypes.index.select: {
      return {
        ...state,
        fetching: false,
        fetched: true,
        select_items: action.payload.busers,
        errors: []
      }
    }

    case busersTypes.index.failure: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errors: action.payload
      }
    }

    // ACTIVATE, DEACTIVATE
    // case busersTypes.activate.request:{
    //   return {
    //     ...state,
    //     setting_status: true,
    //     set_status: false
    //   };
    // }
    //
    // case busersTypes.activate.success:{
    //   return {
    //     ...state,
    //     setting_status: false,
    //     set_status: true,
    //     items: action.payload.busers,
    //     totals: action.payload.totals,
    //     pagination: action.payload.pagination
    //   };
    // }
    //
    // case busersTypes.activate.single:{
    //   const {active} = action.payload.buser
    //   return {
    //     ...state,
    //     setting_status: false,
    //     set_status: true,
    //     buser: {
    //       ...state.buser,
    //       active: active,
    //     }
    //   };
    // }
    //
    // case busersTypes.activate.failure:{
    //   return {
    //     ...state,
    //     setting_status: false,
    //     set_status: false,
    //     errors: action.payload
    //   }
    // }

    // CREATE
    case busersTypes.create.init: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case busersTypes.create.request: {
      return {
        ...state,
        fetching_single: true,
        fetched_single: false,
        must_redirect: false,
        errors: []
      }
    }

    case busersTypes.create.success: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: true,
        must_redirect: true,
        buser: action.payload,
        errors: []
      }
    }

    case busersTypes.create.failure: {
      return {
        ...state,
        fetching_single: false,
        fetched_single: false,
        must_redirect: false,
        errors: action.payload
      }
    }

    default: {
      return {...state};
    }
  }

}



// WEBPACK FOOTER //
// ./src/js/reducers/busersReducer.js